import * as type from './type';
import util from 'common/js/util';

export default {
    // 保存商品
    [type.SAVE_WARE](context,option){
        util.post({
            params:{
                functionId: "sellerCreateOrEditWare",
                body: JSON.stringify(context.state.form)
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
    // 查看商品详情
    [type.GET_WARE_DETAIL](context,option){
        util.post({
            params:{
                functionId: "sellerSelfWareDetail",
                body: JSON.stringify({
                    venderId: option.params.venderId,
                    skuId: option.params.skuId
                })
            },
            sc (data){
                context.commit([type.SET_WARE_DETAIL], data.data);
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
    // 改变商品状态
    [type.CHANGE_WARE_STATE](context,option){
        util.post({
            params:{
                functionId: "sellerChangeWareConditon",
                body: JSON.stringify({
                    spuId: option.params.spuId,
                    venderId: option.params.venderId,
                    target: option.params.target  //0:上架、 1:下架、 2:撤销审核、 3：删除、 4:恢复
                })
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    }

}


// WEBPACK FOOTER //
// ./src/store/create-ware/actions.js